import React, {useState} from 'react';
import {
    Col,
    Row
} from 'reactstrap';

import {ButtonNew, ButtonSync} from "../../../components/buttons/buttonsActions";
import ConfMapsForm from "./_form";
import ConfMapsList from "./_list";
import {showLoader} from "../../../components/loader/loader";
import {confirmAlert} from "react-confirm-alert";
import {
    ARE_YOU_SHURE_TITLE,
    CONFIRM_SYNC,
    CONFIRM_YES, error,
    info,
    NO,
    TOAST_SYNC_PROD_LANG
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {confMapsService} from "../../../jwt/_services/configuration/confMapsService";


export default function ConfMaps(props) {

    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();
    const [loading, setLoading] = useState(false);
    const [viewMode, setViewMode] = useState("LIST")

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    const confirmSyncFirebase = () => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{CONFIRM_SYNC}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            syncFirebase()
                            onClose();
                        }}>
                            {CONFIRM_YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const syncFirebase = () => {
        showToastCustom(info, TOAST_SYNC_PROD_LANG);
        setLoading(true);
        confMapsService.syncFirebase()
            .then(_ => {
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonSync onClick={confirmSyncFirebase}/>
                                    <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {(
                function() {
                    switch (viewMode) {
                        case "LIST" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <ConfMapsList setForm={setForm} app={props.app} />
                                    </Col>
                                </Row>
                            );
                        case "FORM" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <ConfMapsForm setForm={setForm} item={item} app={props.app} />
                                    </Col>
                                </Row>
                            );
                        default:
                            return null;
                    }
                })()}
        </div>
    );
}